import { useCallback } from 'react';
import { useMutation } from 'data-fetching-client';
import { useDispatch } from 'react-redux';
import Log from 'forms-utils-lib/logger/Logger';
import { UPSERT_ROUTING } from '../mutations/upsertRouting';
import { GET_FORM_ROUTING, GET_FORM_ROUTING_FIELD_NAME } from '../queries/getFormRouting';
import { getSubCategoriesFromError } from 'FormsUI/api/Routing';
// @ts-expect-error untyped dependency
import { saveFormError } from 'FormsUI/actions/FormSaving';
// @ts-expect-error untyped dependency
import { FormErrors } from 'FormsUI/api/Forms';
import { captureException } from 'raven-js';
const useUpsertRouting = () => {
  const dispatch = useDispatch();
  const [upsertRouting, {
    loading,
    error
  }] = useMutation(UPSERT_ROUTING, {
    update(cache, {
      data
    }) {
      const response = data && data[GET_FORM_ROUTING_FIELD_NAME];
      if (response) {
        cache.writeQuery({
          query: GET_FORM_ROUTING,
          variables: {
            formGuid: response.formId
          },
          data: {
            [GET_FORM_ROUTING_FIELD_NAME]: response
          }
        });
      }
    },
    onError({
      networkError
    }) {
      const {
        data
      } = networkError;
      const parsedResponse = JSON.parse(data);
      const subCategories = getSubCategoriesFromError(parsedResponse);
      if (subCategories && subCategories.length) {
        const subCategory = subCategories[0];
        Log.error('Failed to upsert forms routing', {
          subCategory
        });
        dispatch(saveFormError(subCategory));
      } else {
        Log.error('Failed to upsert forms routing', {
          subCategory: FormErrors.UNKNOWN
        });
        dispatch(saveFormError(FormErrors.UNKNOWN));
      }
    }
  });
  const updateRouting = useCallback(updatedRouting => {
    upsertRouting({
      variables: {
        formRouting: updatedRouting
      }
    }).catch(captureException);
  }, [upsertRouting]);
  return {
    updateRouting,
    loading,
    error
  };
};
export default useUpsertRouting;